"use client";

import { styled } from "styled-components";

export const Wrapper = styled.div<{ $width: string }>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  width: ${({ $width }) => $width};
  border-radius: var(--Border-Radius-4, 0.4rem);
  border: 1px solid var(--Color-Common-Border-Tertiary, #e5e7eb);
  background: var(--Color-Common-Bg-Primary, #fff);
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.16),
    0px 0px 2px 0px rgba(0, 0, 0, 0.12);
  padding: var(--Spacing-6, 0.6rem);
`;

export const ContentsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
  width: 100%;
`;

export const ContentRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: var(--Spacing-2, 0.2rem);
  flex: 1 0 0;
`;

export const CenterRow = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  gap: var(--Spacing-2, 0.2rem);
  flex: 1 0 0;
`;

export const ContentColumn = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: var(--Spacing-2, 0.2rem);
  align-self: stretch;
`;

export const Title = styled.strong`
  color: var(--Color-Common-Text-Secondary, #515c6c);
  font-family: var(--font-pt-serif);
  font-size: 1.2rem;
  font-style: normal;
  font-weight: 400;
  line-height: 130%;
  flex-shrink: 0;
`;

export const TooltipTitle = styled.strong`
  color: var(--Color-Common-Text-Secondary, #515c6c);
  font-family: var(--font-pt-serif);
  font-size: 1.2rem;
  font-style: normal;
  font-weight: 700;
  line-height: 130%;
  flex-shrink: 0;
`;

const DEFAULT_VALUE_FONT_STYLE = `
  font-family: var(--font-pt-serif);
  font-size: 1.2rem;
  font-style: normal;
  font-weight: 700;
  line-height: 130%;
`;

export const DateText = styled.span`
  color: var(--Color-Common-Text-Primary, #2a2f37);
  ${DEFAULT_VALUE_FONT_STYLE}
`;

export const DrugNameText = styled.span`
  color: var(--Color-Label-Text-Interactive-Medicine, #005eeb);
  ${DEFAULT_VALUE_FONT_STYLE}
`;

export const ModalityText = styled.span`
  color: var(--Color-Label-Text-Interactive-Modality, #8219d2);
  ${DEFAULT_VALUE_FONT_STYLE}
`;

export const TherapeuticAreaText = styled.span`
  color: var(--Color-Label-Text-Interactive-Disease, #db0f72);
  ${DEFAULT_VALUE_FONT_STYLE}
`;

export const TargetIndicationText = styled.span`
  color: var(--Color-Label-Text-Interactive-Disease, #db0f72);
  ${DEFAULT_VALUE_FONT_STYLE}
`;

export const PhaseText = styled.span`
  color: var(--Color-Label-Text-Interactive-Phase-Pressed, #bdb300);
  ${DEFAULT_VALUE_FONT_STYLE}
  text-transform: capitalize;
`;

export const CompanyText = styled.span`
  color: var(--Color-Common-Text-Primary, #2a2f37);
  ${DEFAULT_VALUE_FONT_STYLE}
  width: 100%;

  display: inline;
`;

export const CountryFlagWrapper = styled.span`
  display: inline-flex;
  gap: 0.2rem;

  .vc-trends-country-flag-wrapper {
    width: auto;
    height: auto;
    padding: 0;
  }
`;

export const TypeText = styled.span`
  color: var(--Color-Label-Text-Interactive-Endpoint, #29b5c2);
  ${DEFAULT_VALUE_FONT_STYLE}
  text-transform: capitalize;
`;

export const DescriptionText = styled.span<{ $lineClamp?: number }>`
  color: var(--Color-Common-Text-Primary, #2a2f37);
  ${DEFAULT_VALUE_FONT_STYLE}
  display: -webkit-box;
  -webkit-line-clamp: ${({ $lineClamp }) => $lineClamp || 5};
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

export const ValueTextRow = styled.div`
  display: flex;
  align-items: baseline;
  flex-wrap: wrap;
  gap: var(--Spacing-2, 0.2rem);
`;

export const ValueText = styled.span`
  color: var(--Color-Label-Text-Interactive-Payment, #597181);
  ${DEFAULT_VALUE_FONT_STYLE}
`;

export const DollarValueText = styled(ValueText)`
  font-size: 1.1rem;
`;
export const TargetText = styled.span`
  color: var(--Color-Label-Text-Interactive-Target, #eb8d00);
  ${DEFAULT_VALUE_FONT_STYLE}
`;

export const MoaText = styled.span`
  color: var(--Color-Common-Text-Primary, #2a2f37);
  ${DEFAULT_VALUE_FONT_STYLE}
`;

export const CountText = styled.span`
  color: var(--Color-Common-Text-Tertiary, #7c899c);
  text-align: center;
  font-family: var(--font-pretendard);
  font-size: 1.2rem;
  font-weight: 500;
  line-height: 130%;
`;

export const ModalityIconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1.4rem;
  height: 1.6rem;
  padding-top: 0.2rem;
`;
